import {
  Button,
  Card,
  Row,
  Space,
  Tabs,
  Typography,
  message as AntDesignMessage,
} from "antd";
import React from "react";
import { ConnectWalletInstruction } from "../component/ConnectWallet/ConnectWalletInstruction";
import { DepositWithdrawInput } from "../component/Farm/DepositWithdrawInput";
import { Loading } from "../component/Loading/Loading";
import { BN, contracts, divisor } from "../constants";
import { Web3Context } from "../store/Web3Store";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const WAGMI_V2_ADDRESS = "0xad941e29887f6b0B4f58d6B5fbC3A3AeCA9d684F";
const XWAGMI_ADDRESS = "0x8d7B20a5Ec6B241b5Cfd61F9d2307c43e424759b";

export const XWagmiPage = () => {
  const { web3, account } = React.useContext(Web3Context);
  const [amount, setAmount] = React.useState(0);
  const [xWagmiData, setXWagmiData] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const handleReload = async () => {
    const wagmiV2Contract = new web3.eth.Contract(
      contracts.wagmiV2AbiJson,
      WAGMI_V2_ADDRESS
    );
    const xWagmiContract = new web3.eth.Contract(
      contracts.xWagmiAbiJson,
      XWAGMI_ADDRESS
    );
    const wagmiV2Balance = new BN(
      await wagmiV2Contract.methods.balanceOf(account).call()
    ).div(divisor);
    const xWagmiBalance = new BN(
      await xWagmiContract.methods.balanceOf(account).call()
    ).div(divisor);
    const approvalLimit = new BN(
      await wagmiV2Contract.methods.allowance(account, XWAGMI_ADDRESS).call()
    ).div(divisor);
    const isApproved = wagmiV2Balance.lt(approvalLimit);

    setXWagmiData({
      wagmiV2Balance: wagmiV2Balance.toFixed(),
      xWagmiBalance: xWagmiBalance.toFixed(),
      isApproved,
    });
  };

  const mainFunc = async () => {
    setLoading(true);
    await handleReload();
    setLoading(false);
  };

  const handleApproval = () => {
    const wagmiV2Contract = new web3.eth.Contract(
      contracts.wagmiV2AbiJson,
      WAGMI_V2_ADDRESS
    );
    return wagmiV2Contract.methods
      .approve(
        XWAGMI_ADDRESS,
        "115792089237316195423570985008687907853269984665640564020457584007913129639935"
      )
      .send({
        from: account,
      })
      .then(() => {
        AntDesignMessage.success("xWAGMI Contract Approved!", 10);
        handleReload();
      })
      .catch((error) => {
        AntDesignMessage.error(error.message, 10);
        handleReload();
      });
  };

  const handleDeposit = () => {
    const xWagmiContract = new web3.eth.Contract(
      contracts.xWagmiAbiJson,
      XWAGMI_ADDRESS
    );
    return xWagmiContract.methods
      .enter(new BN(amount).times(divisor).toFixed())
      .send({ from: account })
      .then(() => {
        AntDesignMessage.success(`Successfully deposited!`, 10);
        handleReload();
      })
      .catch((error) => {
        AntDesignMessage.error(error.message, 10);
        handleReload();
      });
  };

  const handleWithdraw = () => {
    const xWagmiContract = new web3.eth.Contract(
      contracts.xWagmiAbiJson,
      XWAGMI_ADDRESS
    );
    return xWagmiContract.methods
      .leave(new BN(amount).times(divisor).toFixed())
      .send({ from: account })
      .then(() => {
        AntDesignMessage.success(`Successfully Withdrew!`, 10);
        handleReload();
      })
      .catch((error) => {
        AntDesignMessage.error(error.message, 10);
        handleReload();
      });
  };

  React.useEffect(() => {
    if (web3) {
      mainFunc();
    }
  }, [account]);

  if (!web3) {
    return <ConnectWalletInstruction />;
  } else if (loading) {
    return <Loading />;
  }

  return (
    <Row justify="center">
      <Card
        title="xWAGMI"
        extra={
          <img
            className="cover coin-image"
            src="/wagmi-logo.png"
            alt="xWagmi"
          />
        }
      >
        <Space direction="vertical">
          <Text strong>Single Assets Staking, for WAGMI HODLERs</Text>
          <Text>
            stake $WAGMI and earn 3% of the transaction fee of $WAGMI (5%
            transaction fee being charged for $WAGMI)
          </Text>
          <br />
          <Tabs
            defaultActiveKey="1"
            onChange={() => {
              setAmount(0);
            }}
          >
            <TabPane tab="Deposit" key="1">
              <Row justify="center">
                <Space direction="vertical">
                  <DepositWithdrawInput
                    maxAmount={xWagmiData.wagmiV2Balance}
                    symbol="WAGMI"
                    amount={amount}
                    setAmount={setAmount}
                  />
                  <Row justify="end">
                    {xWagmiData.isApproved ? (
                      <Button type="primary" onClick={handleDeposit}>
                        Deposit
                      </Button>
                    ) : (
                      <Button type="primary" onClick={handleApproval}>
                        Approve Contract
                      </Button>
                    )}
                  </Row>
                </Space>
              </Row>
            </TabPane>
            <TabPane tab="Withdraw" key="2">
              <Row justify="center">
                <Space direction="vertical">
                  <DepositWithdrawInput
                    maxAmount={xWagmiData.xWagmiBalance}
                    symbol="xWAGMI"
                    amount={amount}
                    setAmount={setAmount}
                  />

                  <Row justify="end">
                    <Button type="primary" onClick={handleWithdraw}>
                      Withdraw
                    </Button>
                  </Row>
                </Space>
              </Row>
            </TabPane>
          </Tabs>
        </Space>
      </Card>
    </Row>
  );
};
